import asyncComponent from '../../components/AsyncComponent';

const Letters = asyncComponent(() => import('../../containers/Letter/LetterList'));

export default Letters;
